// extracted by mini-css-extract-plugin
export default {"investCurrency":"InvestCurrency_investCurrency__sI80d"};